<script>
import TheMixin from "../../mixin/TheFooter";
import { getStoreOption } from "@utils/ipetbooking-options";

export default {
  mixins: [TheMixin],
  data() {
    return {
      shopUrl: window.globalData.APP_SHOP_URL,
      visibleList: [],
    }
  },
  computed: {
    storeItem() {
      return getStoreOption({
        value: this.$route.params.storeAlias,
        type: 'item'
      })
    },
    menuList() {
      return [
        {
          title: '會員中心',
          children: [
            {
              menuTitle: '我的購物訂單',
              url: 'https://auth.j-tails.com/member/shopOrder'
            }
          ]
        },
        {
          title: '購物條款',
          children: [
            {
              menuTitle: '常見問題',
              url: `${this.shopUrl}/faq`
            },
            {
              menuTitle: '使用細則＆隱私權條款',
              url: `${this.shopUrl}/privacy`
            }
          ]
        },
        {
          title: '相關服務',
          children: [
            {
              menuTitle: '線上購物',
              url: `${this.shopUrl}`
            }
          ]
        }
      ]
    }
  },
  created() {
    this.visibleList = this.menuList.map(() => false)
  },
  methods: {
    onClickToggleVisible(index) {
      this.visibleList[index] = !this.visibleList[index]
      this.visibleList = [...this.visibleList]
    },
  },
}
</script>
<!-- section template -->
<template>
  <footer :class="$style.footer">
    <div class="container--shop--small">
      <div class="footerBottom">
        <div class="row footerBottomList">
          <img alt="" class="logo__back" src="@assets/images/jtails/wordpress/footer_background_logo.svg">
          <template v-for="(item, index) in menuList">
            <div :key="index" class="col-md col-12 footerBottom__Item">
              <div class="footerMenu" :class="{ isActive: visibleList[index] }">
                <div class="footerMenu__title" @click="onClickToggleVisible(index)">{{ item.title }}</div>
                <div class="footerMenu__menuList">
                  <template v-for="(menu, menuIndex) in item.children">
                    <a :key="menuIndex" :href="menu.url" class="footerMenu__menuItem">{{ menu.menuTitle }}</a>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <div class="footerBottom__Item isSocial col-lg col-12">
            <div class="socialMenu__list isStyleFooter">
              <a href="https://www.instagram.com/jtailspet/" class="socialMenu__item" target="_blank">
                <i class="fontello fontello-instagram"></i>
              </a>
              <a href="https://www.facebook.com/Jtailspetspa" class="socialMenu__item" target="_blank">
                <i class="fontello fontello-facebook"></i>
              </a>
              <a href="http://line.me/ti/p/@jtails" class="socialMenu__item" target="_blank">
                <i class="fontello fontello-line"></i>
              </a>
            </div>
            <img alt="" class="logo" src="@assets/images/jtails/wordpress/footer_logo.svg">
            <img alt="" class="logo isMobile" src="@assets/images/jtails/wordpress/footer_background_logo.svg">
          </div>
        </div>
      </div>
      
    </div>
    <div class="copyRight">
      <div class="container--shop--small">
        <div class="d-flex justify-content-center justify-content-md-between flex-column flex-md-row lh-2 align-items-center">
          <span>© J’ Tails 2022. All rights reserved.</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<!-- section style -->
<style lang="scss" module>
.footer {
  position: relative;
  z-index: 0;
  border-top: 1px solid $color-primary;
  border-bottom: 5px solid $color-primary;

  :global {
    .footer {
      &__copyright {
        a {
          @include link-unstyled;

          color: $color-primary;

          &:hover, &:focus {
            color: darken($color-primary, 10%);
          }
        }
      }

    }

    .footerBottom {
      position: relative;
      padding: 60px 0;

      @include max-md {
        padding: 40px 0 0 0;
      }
      &List {
        position: relative;
        z-index: 0;

        .logo__back {
          position:absolute;
          right: 0;
          top: -20px;
          z-index: -1;

          @include max-md {
            display: none;
          }
        }
      }
      &__Item {
        @include max-md {
          margin-bottom: 10px;
          text-align: center;
        }
        &.isSocial {
          display: flex;
          position: relative;
          flex-direction: column-reverse;
          order: -1;

          @include max-lg {
            order: inherit;
          }

          @include max-md {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 2rem;

            &::before {
              content: '';
              position: absolute;
              top: -30px;
              height: 1px;
              background-color: $color-line;
              left: 15px;
              right: 15px;
            }
          }
          .logo {
            width: 196px; 
            margin-bottom: 3.125rem;

            @include max-md {
              width: 150px;
              display: none;
            }
            
            &.isMobile {
              display: none;
              margin-bottom: 0;
              margin-top: 3.125rem;
              @include max-md {
                display: inherit;
              }
            }
          }
        }
      }

    }

    .footerMenu {
      margin-bottom: 2rem;

      @include max-md {
        text-align: left;
        margin-bottom: 10px;
      }
      &.isActive {
        .footerMenu {
          &__menuList {
            max-height: 300px;
          }
          &__title {
            &::after {
              transform: rotate(0.5turn);
            }
          }
        }
      }
      &__icon {
        display: none !important;

        @include max-md {
          display: inline-block !important;
        }
      }
      &__title {
        position: relative;
        margin-bottom: 1.875rem;
        font-size: 16px;
        font-weight: 400;
        color: $color-wp-text;
        letter-spacing: 0.25em;
        cursor: pointer;

        @include max-md {
          position: relative;
          display: flex;
          margin-bottom: .5rem;
          text-align: left;
          &::after {
            position: absolute;
            top: -2px;
            right: 0;
            padding-left: 5px;
            font-family: 'fontello';
            font-size: 18px;
            content: '\E81A';
            transition: .3s;
            transform-origin: center;
          }
        }
      }
      &__menuList {
        display: flex;
        flex-direction: column;

        @include max-md {
          max-height: 0;
          margin-bottom: 10px;
          overflow: hidden;
          transition: max-height 0.3s ease-out;
          padding-left: 20px;
        }
      }
      &__menuItem {
        font-size: 14px;
        line-height: 2.5em;
        color: $color-text;
        text-decoration: none;
        letter-spacing: 0.2em;
        &:hover {
          color: $color-wp-text;
          text-decoration: none
        }

        @include max-md {
          text-align: left;
        }
      }
    }

    .logo__back {
      width: auto;
      position: absolute;
      right: 0;
      top: -20px;
      z-index: -1;

      @include max-md {
        display: none;
      }
    }

    .socialMenu{
      &__list {
        display: flex;
        align-items: center;
        &.isStyleMenu {
          width: 194px;
          justify-content: space-between;
          .socialMenu {
            &__item {
              font-size: 20px;
              text-decoration: none;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 38px;
              height: 38px;
              background: rgba($color-secondary, 0.15);
              color: $color-secondary;
              border-radius: 100%;
              letter-spacing: 0;
              &:hover {
                background: rgba($color-secondary, 0.3);
              }
            }
          }
        }
        &.isStyleFooter {
          .socialMenu {
            &__item {
              background: rgba($color-secondary, 0.15);
              color: $color-secondary;
              margin: 0 6px;
              width: 38px;
              height: 38px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 100%;
              font-size: 20px;
              padding-left: 2px;
              text-decoration: none;
              transition: background 0.3s;
              &:first-child {
                margin-left: 0;
              }
              &:hover {
                background: rgba($color-secondary, 0.3);
              }
            }
          }
        }
      }
      &__item {

      }
    }

    .copyRight {
      padding: 4rem 0;
      font-size: 14px;
      color: $color-text;
      letter-spacing: 3.2px;

      @include max-md {
        padding: 1rem 0;
        text-align: center;
      }
    }
  }
}

.menuList {
  @include list-unstyled;

  :global {
    .menuList {
      &__item {
        @include unstyled;
      }

      &__link {
        @include link-unstyled;

        font-size: 0.875rem;
        line-height: 2;
        color: #726F65;
        cursor: pointer;

        &:hover, &:focus {
          color: $color-primary;
        }

        &.isActive {
          color: $color-primary;
          text-decoration: underline;
        }
      }
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  :global {
    .socialList {
      &__item {
        &:not(:last-child) {
          margin-right: 1.5rem;
        }
      }

      &__link {
        @include link-unstyled;
        // height: 39px;
        // width: 39px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 3px;
        font-size: 1.5rem;
        color: #3F3A2E;
        cursor: pointer;
        // background: rgba(#726F65, 0.15);
        border-radius: 100%;
        transition: color 0.3s, background 0.3s;

        &:hover, &:focus {
          color: $color-primary;
          // background: rgba(#726F65, 0.2);
        }
      }
    }
  }
}
</style>
